'use strict'

angular.module('rmCampaign')

    .config(['$stateProvider', function ($stateProvider) {

        async function createBladeIfNotExists (bladesManager, options, level = 0) {
            if (!bladesManager.all(level).some(el => el.viewName === options.viewName)) {
                await bladesManager.insertRight(options, level)
            }
        }

        let schedule = {
            url: '/schedule',
            views: {
                'schedule@': {
                    templateUrl: '/partial/app.partials.campaign.schedule_week',
                    controller: 'CampaignScheduleCtrl',
                    controllerAs: 'schedule',
                },
            },
            params: {
                title: null,
                campaign: null,
            },
            resolve: {
                zoomFactor: ['$http', $http => (
                    $http.get('/usersettings')
                        .then(req => (req.data.zoomFactor || 100))
                )],
            },
            onEnter: ['bladesManager', async bladesManager => {
                await createBladeIfNotExists(bladesManager, { viewName: 'campaignoverview', size: 'half' })
                await createBladeIfNotExists(bladesManager, { viewName: 'campaigndetail', size: 'half' })
                await createBladeIfNotExists(bladesManager, { viewName: 'schedule', size: 'full' }, 1)
            }],
            onExit: ['$state', 'bladesManager', ($state, bladesManager) => {
                if (!/^campaign\.(create|update)\.schedule/.test($state.transition.to().name)) {
                    bladesManager.removeAll(1)
                }
            }],
        }

        let item = {
            url: '/item',
            views: {
                'itemdetail@': {
                    templateUrl: '/partial/app.partials.campaign.item_detail',
                    controller: 'CampaignItemCtrl',
                    controllerAs: 'ctrl',
                },
            },
            params: {
                title: null,
            },
            onEnter: ['bladesManager', async bladesManager => {
                await createBladeIfNotExists(bladesManager, { viewName: 'campaignoverview', size: 'half' })
                await createBladeIfNotExists(bladesManager, { viewName: 'campaigndetail', size: 'half' })
                await createBladeIfNotExists(bladesManager, { viewName: 'schedule', size: 'full' }, 1)
                await createBladeIfNotExists(bladesManager, { viewName: 'itemdetail', size: 'half' }, 2)
            }],
            onExit: ['$state', 'bladesManager', ($state, bladesManager) => {
                if (!/^campaign\.(create|update)\.schedule\.item/.test($state.transition.to().name)) {
                    bladesManager.removeAll(2)
                }
            }],
        }

        let itemContact = {
            url: '/contact/:contactId',
            params: {
                create: false
            },
            views: {
                'contact@': {
                    templateUrl: '/partial/app.partials.contact.detail',
                    controller: 'ContactFormCtrl',
                    controllerAs: 'contactCtrl',
                },
            },
            onEnter: ['bladesManager', async bladesManager => {
                await createBladeIfNotExists(bladesManager, { viewName: 'campaignoverview', size: 'half' })
                await createBladeIfNotExists(bladesManager, { viewName: 'campaigndetail', size: 'half' })
                await createBladeIfNotExists(bladesManager, { viewName: 'schedule', size: 'full' }, 1)
                await createBladeIfNotExists(bladesManager, { viewName: 'itemdetail', size: 'half' }, 2)
                await createBladeIfNotExists(bladesManager, { viewName: 'contact', size: 'half' }, 2)
            }],
            onExit: ['$state', '$stateParams', 'Contact', 'bladesManager', ($state, $stateParams, Contact, bladesManager) => {

                // //Delete if contact was in creation mode
                // let allContacts = $stateParams.campaign.item.contacts,
                //     id = parseInt($stateParams.contactId);
                // if (allContacts.filter(row => id == row.id).length === 0) {
                //     Contact.delete({id});
                // }
                //ugly workaround to check if contact has actually been properly saved.. yeah...
                let contact = Contact.get({ id: $stateParams.contactId }, () => {
                    let contactHasProbablyBeenSaved = contact.firstname && contact.lastname
                    if ($stateParams.create === true && !contactHasProbablyBeenSaved) {
                        Contact.delete({ id: $stateParams.contactId })
                    }
                })

                if (!/^campaign\.(create|update)\.schedule\.item\.contact/.test($state.transition.to().name)) {
                    bladesManager.removeRight('contact', 2)
                }
            }],
        }

        $stateProvider
            .state('campaign', {
                url: '/campaigns',

                views: {
                    'campaignoverview': {
                        templateUrl: '/partial/app.partials.campaign.overview',
                        controller: 'CampaignOverviewCtrl',
                        controllerAs: 'campaignCtrl',
                    },
                    'campaigndetail': {
                        templateUrl: '/partial/app.panels.empty',
                    },
                },

                onEnter: ['bladesManager', async bladesManager => {
                    await new Promise(r => bladesManager.clearAll(r))
                    await createBladeIfNotExists(bladesManager, { viewName: 'campaignoverview', size: 'half' })
                    await createBladeIfNotExists(bladesManager, { viewName: 'campaigndetail', size: 'half' })
                }],

                resolve: {

                    itemFilters: ['$http', $http => (
                        $http.get('/usersettings')
                            .then(({ data }) => data.item_filter)
                    )],

                    filterMap: ['$http', $http => (
                        $http.get('/userfilters/campaign')
                            .then(({ data }) => data.userFilters)
                    )],
                },
            })

            .state('campaign.create', {
                url: '/create',
                views: {
                    'campaigndetail@': {
                        templateUrl: '/partial/app.partials.campaign.detail',
                        controller: 'CampaignFormCtrl',
                        controllerAs: 'campaignCtrl',
                    },
                },
            })
            .state('campaign.create.schedule', angular.copy(schedule))
            .state('campaign.create.schedule.item', angular.copy(item))
            .state('campaign.create.schedule.item.contact', angular.copy(itemContact))

            .state('campaign.update', {
                url: '/update/:id',
                views: {
                    'campaigndetail@': {
                        templateUrl: '/partial/app.partials.campaign.detail',
                        controller: 'CampaignFormCtrl',
                        controllerAs: 'campaignCtrl',
                    },
                },
            })
            .state('campaign.update.schedule', angular.copy(schedule))
            .state('campaign.update.schedule.item', angular.copy(item))
            .state('campaign.update.schedule.item.contact', angular.copy(itemContact))
    }])
